const theme = {
  textColor: "white",
  fonts: {
    headerFont: '"Cal Sans", sans-serif',
    mainFont: '"Montserrat", sans-serif',
    subFont: '"Playfair Display", serif',
  },
  fontSizes: {
    xs: "0.8rem",
    sm: "1rem",
    m: "1.3rem",
    l: "2.5rem",
    xl: "3.5rem",
  },
};

export default theme;
